import { Dialog } from 'primereact/dialog';
import classes from './futureAddedPopUp.module.scss';
import { Button } from 'primereact/button';
import { Player } from '@lottiefiles/react-lottie-player';
import successAnimation from 'assets/lottieFiles/successAnimation.json';
import { useFutureAddedPopUp } from './usefutureAddedPopUp';

const FutureNdcAddedPopUp = ({
  visibility,
  toggleVisibility,
  addedFutureNDCData,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  addedFutureNDCData: { heading: string; value: string; startDate: string; endDate: string }[];
}) => {
  const { getPPSReasonData } = useFutureAddedPopUp();
  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={'New NDC added values'}
      visible={visibility}
      style={{ width: '55vw', background: 'grey' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.newFutureTmsContainer}>
        <Player autoplay keepLastFrame className={classes.lottiePlayer} src={successAnimation} />
        {addedFutureNDCData.map((instance, index) => {
          return (
            <>
              {instance.heading.toLocaleLowerCase() === 'pps reason' ? (
                <></>
              ) : (
                <div className={classes.tableInstance} key={index}>
                  <div className={classes.tableHeading}>
                    {instance.heading === 'DP Strategy' ? 'Demand Planning' : instance.heading}
                  </div>
                  {instance.heading.toLocaleLowerCase() === 'pps' ? (
                    <table>
                      <thead>
                        <tr>
                          <th>PPS value</th>
                          <th>PPS Reason Value</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{instance.value}</th>
                          <th>{getPPSReasonData(addedFutureNDCData)?.value}</th>
                          <th>{instance.startDate}</th>
                          <th>{instance.endDate}</th>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{instance.value}</th>
                          <th>{instance.startDate}</th>
                          <th>{instance.endDate}</th>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </>
          );
        })}

        <div className={classes.closeButtonDivWrapper}>
          <Button className={classes.closeButton} onClick={toggleVisibility}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default FutureNdcAddedPopUp;
